import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import utagUtils from 'utils/utag'
import config from 'const/config'
import { PrimaryButton } from 'ui/molecules/RequestPage.styles'
import type { ResultPageState, SFDDLProps } from 'typings'
import useCustomTranslation from 'hooks/useCustomTranslation'
import {
  Anchor,
  ButtonContainer,
  Container,
  LinkAnchor
} from './ResultPage.styles'

// eslint-disable-next-line @typescript-eslint/no-namespace
declare namespace window {
  // eslint-disable-next-line no-underscore-dangle, @typescript-eslint/naming-convention
  const _SFDDL: SFDDLProps
}

const ResultPage = (): JSX.Element => {
  const t = useCustomTranslation('result')

  const navigate = useNavigate()
  const location = useLocation()
  // do this way instead of deconstruct due to nullable props
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const state = location?.state as ResultPageState
  const status = state?.status
  const trackingId = state?.trackingId
  const backToForm =
    config.BASENAME === '/' ? config.BASENAME : `${config.BASENAME}/`

  useEffect(() => {
    if (!trackingId) navigate('/')
  })

  // set props for this page, get reference from global object
  useEffect(() => {
    // eslint-disable-next-line no-undef, no-var, no-underscore-dangle, no-use-before-define, @typescript-eslint/naming-convention
    const _SFDDL = window._SFDDL || { pageInfo: {} }
    if (_SFDDL && _SFDDL.pageInfo) {
      _SFDDL.pageInfo.PageSubFunction = 'verification'
      _SFDDL.pageInfo.PageName = 'complete'
    }
    // update view to track events
    utagUtils.view()
  }, [])

  return (
    <Container>
      {status ? (
        <span>
          {t('successBefore')}
          {trackingId}
          {t('messageAfter')}
        </span>
      ) : (
        <span className="failure">
          {t('failureBefore')}
          {trackingId}
          {t('messageAfter')}
        </span>
      )}
      <ButtonContainer>
        <Anchor href="https://www.synchrony.com/">
          <PrimaryButton
            type="button"
            className="ensightencustomevent"
            data-type="button"
            data-reason="gotosynchrony"
          >
            {t('goTo')}
          </PrimaryButton>
        </Anchor>
        {/** Use regular anchor instead of router to fore add a slash at the end */}
        <LinkAnchor
          href={backToForm}
          className="ensightencustomevent"
          data-type="link"
          data-reason="backtoform"
        >
          {t('back')}
        </LinkAnchor>
      </ButtonContainer>
    </Container>
  )
}

export default ResultPage
